const generateGroupAssignmentValues = (referenceMap) => {
    if (referenceMap?.interventionDescriptionReference && referenceMap.comparatorDescriptionReference) {
        return {
            "definition": {
                "concept": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "defined-in-handling-and-category",
                            "display": "Defined in handling and category elements"
                        }
                    ]
                }
            },
            "handling": "dichotomous",
            "category": [
                {
                    "name": referenceMap.interventionDescriptionReference.display || "intervention",
                    "valueReference": referenceMap.interventionDescriptionReference
                },
                {
                    "name": referenceMap.comparatorDescriptionReference.display || "comparator",
                    "valueReference": referenceMap.comparatorDescriptionReference
                }
            ]
        }
    }
};

export default generateGroupAssignmentValues;